module.exports = __webpack_public_path__ + "static/media/IGCSE_edexcel_logo.9676e079.jpg";